import type { ReactNode } from 'react'

import { cn } from '@/shared/lib'

type SectionHeaderProps = {
  /** Section number — `01`, `02`. Rendered as `01 — Title`. */
  index?: string
  children: ReactNode
  className?: string
}

/**
 * Mono accent heading followed by a 1px rule that fades to transparent. The
 * rule is how Verdant separates sections — never a solid divider or a heavier
 * border.
 */
export function SectionHeader({ index, children, className }: SectionHeaderProps) {
  return (
    <div
      data-slot="section-header"
      className={cn('flex items-baseline gap-3', className)}
    >
      <h2 className="font-mono text-h3 leading-heading font-semibold tracking-eyebrow text-accent-text uppercase">
        {index !== undefined && `${index} — `}
        {children}
      </h2>
      <div
        aria-hidden
        className="h-px flex-1 bg-linear-to-r from-border-strong to-transparent"
      />
    </div>
  )
}
